import { Box } from '@/shared/ui/box/Box';
import { Section, SectionBlocks } from '@/widgets/game-section/ui/styles';
import { SkeletonLoader } from '@/shared/ui/skeleton/skeleton';
import { getSkeletonLoaderImageStyle } from '@/widgets/game-sections/ui/styles';

const PopularGamesSkeleton = () => {
  const styleForImage = getSkeletonLoaderImageStyle();

  return (
    <Box>
      <SectionBlocks>
        <div>
          <SkeletonLoader width={148} height={36} />
        </div>
      </SectionBlocks>
      <Section $hasScroll={true} $rows={2}>
        {[...Array(12)].map((_, index) => (
          <SkeletonLoader
            key={`card_${index}`}
            style={styleForImage}
            width="100%"
            height="100%"
          />
        ))}
      </Section>
    </Box>
  );
};

export { PopularGamesSkeleton };
